export default __webpack_public_path__ + "static/media/commingSoonTr.c1a01765.png";